import * as React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import ButtonGroup from '@mui/material/ButtonGroup';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import { styled } from '@mui/material/styles';
import * as Server from "./Server.js"
import QueryDialog from './DisplayURLDialog.js';
import Avatar from '@mui/material/Avatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import DeleteIcon from '@mui/icons-material/Delete';
import ImageList from '@mui/material/ImageList';
import ImageListItem from '@mui/material/ImageListItem';
import './LiveControls.css';
import ImageListItemBar from '@mui/material/ImageListItemBar';
import ListSubheader from '@mui/material/ListSubheader';
import IconButton from '@mui/material/IconButton';
import Snackbar from '@mui/material/Snackbar';
import Typography from '@mui/material/Typography';
import Container from '@mui/material/Container';
import Box from '@mui/material/Box'
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import {label} from './Dictionary.js';
import LiveStatus from './LiveStatus.js';

function Library({set_battery_level_fn}) {

    const [config, setConfig] = React.useState(null);
    const [image_cache, setImageCache] = React.useState({root:{items:{}}});
    const [openSnack, setOpenSnack] = React.useState(false);
    const [snackKey, setSnackKey] = React.useState(1);
    const [isWakeDialogOpen, setWakeDialogOpen] = React.useState(false);
    const [isLoading, setLoading] = React.useState(false); 
    const searchParams = new URLSearchParams(document.location.search);

    function updateImageCache()
    {
        Server.GetDeviceDetails(searchParams.get("device_id"))
        .then((res) => {
           set_battery_level_fn(res.data.battery_level, res.data.status)
           // console.log(res.data.queue)
           setImageCache(res.data.image_cache)
           setConfig(res.data.config);
        })
        .catch((err) => setImageCache([]));        
    }

    function onAddClicked(cache_key, key, queue) 
    {
        let device_id = searchParams.get("device_id");
        if (!queue) {

            Server.GetDeviceDetails(device_id)
                .then((res) => {
                    if (res.data.status == "Active") {
                        Server.AddFromImageCache(device_id, cache_key, key, queue).then(()=>{
                
                            setLoading(true)
                            Server.AwaitImageChange(device_id, res.data.current_image_url).then((res)=>{
                                setLoading(false)
                                if (res == "Sleeping")
                                    setWakeDialogOpen(true)
                            })

                        }).catch((err) => {
                            setLoading(false)
                        })

                    } else
                        setWakeDialogOpen(true) 
                });     

        } else {
            Server.AddFromImageCache(device_id, cache_key, key, queue)
            setOpenSnack(true)
            setSnackKey(new Date().getTime())
        }
    }

    function onDeleteClicked(cache_key, image_id)
    {
        Server.DeleteImage(searchParams.get("device_id"), cache_key, image_id).then(()=>{
            updateImageCache()
        })
    }

    React.useEffect(() => {
        window.addEventListener("focus", function(){
            updateImageCache();
        })        
        updateImageCache();
    }, []);

    if (!config)
        return (<></>);

    let list_images = []
    Object.keys(image_cache).forEach((cache_key) => {
        Object.keys(image_cache[cache_key].items).forEach((key) => {
            let item = image_cache[cache_key].items[key]
            if (typeof(item) == "object") {
                let url = item[config.orientation].thumb_url
                list_images.push (
                    <ImageListItem key={url}>
                        
                        <img 
                        srcSet={`${url}`}
                        src={`${url}`}
                        // alt={item.title}
                        loading="lazy"
                        onClick={()=>{onAddClicked(cache_key, key, false)}}
                        />

                        <ImageListItemBar
                        actionIcon={
                            <ButtonGroup>
                        <IconButton
                            sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                            onClick={() => {onAddClicked(cache_key, key, true)}}
                        >
                        <AddIcon />
                        </IconButton>
                        <IconButton
                            sx={{ color: 'rgba(255, 255, 255, 0.54)' }}
                            onClick={() => {onDeleteClicked(cache_key, key)}}
                        >
                        <DeleteIcon />
                        </IconButton>
                        </ButtonGroup>
                        }
                        />
                        </ImageListItem>
                )
            }})
    });

    return (
        <>
        <LiveStatus isLoading={isLoading} isNeedsWake={isWakeDialogOpen} onWakeDialogClick={()=>{setWakeDialogOpen(false)}}></LiveStatus>
        { list_images.length==0 ? (
         <>
         <Card sx={{ maxWidth: 445 }}>
          <CardContent>
          <Typography gutterBottom variant="h5" component="div">
          {label("ID_Library")}
          </Typography>
          <Typography variant="body1" sx={{ color: 'text.secondary' }}>
          {label("ID_EmptyLibraryMessage")}
          </Typography>
          </CardContent>
          </Card>
          </>
        ) : (
            <>
        <ImageList cols={Math.floor(document.documentElement.clientWidth/190)} >
            {list_images}
        </ImageList>
        <Box sx={{height:`140px`}}/>
        </>
      )}
      <Snackbar
        open={openSnack}
        autoHideDuration={3000}
        message={label("ID_AddedToPlaylist")}
        key={snackKey}
        onClose={() => {setOpenSnack(false)}}
        />      
        </>
    );
}

export default Library;

